module.exports = __webpack_public_path__ + "static/img/img-presenter-women-v2.aee06f5.png";